import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { desktop_medium, mobile_xl, tablet } from '../../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter, HideScrollbar, LineClamp } from '../../../../../global/commonStyle';

const SectionDiv = styled.div`
  min-width: 540px;
  width: 100%;
  position: relative;
  height: 100dvh;
  ${tablet(css`
    min-width: 430px;
  `)}
  ${desktop_medium(css`
    min-width: unset;
  `)}
  ${tablet(css`
    display: none;
  `)}
  ${mobile_xl(css`
    height: calc(100dvh - 80px);
    display: flex;
    width: 100%;
  `)}
`;

const GradientDiv = styled.div`
  position: absolute;
  bottom: -7px;
  left: 0;
  height: 250px;
  width: 100%;
  background: var(--background-overlay-gradient);
  z-index: var(--z-index-999);
  ${tablet(css`
    display: none;
  `)}
`;

const CardContainer = styled.div`
  min-width: 748px;
  margin-inline: var(--space-8);
  border-radius: var(--border-radius-12);
  border-width: 0.5px;
  background: var(--background-tertiary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--card-content-shadow);
  border-bottom: unset;
  border-bottom-left-radius: var(--border-radius-0);
  height: calc(100dvh - 150px);
  ${HideScrollbar}
  ${desktop_medium(css`
    min-width: unset;
    margin-right: var(--space-0);
    border-top-right-radius: var(--border-radius-0);
    border-bottom-right-radius: var(--border-radius-0);
    border-right: unset;
  `)}
  ${mobile_xl(css`
    overflow: unset;
    background: var(--background-secondary);
    position: relative;
    margin-inline: var(--space-0);
    height: calc(100dvh - 144px);
    border: none;
    box-shadow: none;
    width: 100%;
  `)}
`;

const HeaderSection = styled.div`
  padding: var(--space-16) var(--space-20);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  position: sticky;
  top: 0;
  background-color: var(--background-tertiary);
  z-index: var(--z-index-999);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const CardIcon = styled.div`
  padding: var(--space-8);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  background-color: var(--background-primary);
  ${FlexCenter}
`;

const TabSection = styled.div`
  max-width: 260px;
  width: 100%;
  ${AlignCenter}
  gap: var(--space-8);
  opacity: 0.6;
`;

const TabItem = styled.div`
  height: 18px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
  width: 100%;
`;

const BottomSection = styled.div`
  padding: var(--space-20);
  width: calc(100% - 40px);
  opacity: 0.6;
  display: flex;
  flex-direction: column;
  gap: var(--space-32);
`;

const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;

const ListTitle = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-full);
  height: 12px;
  width: 100px;
`;

const BorderDiv = styled.div`
  border-bottom: 0.5px solid var(--border-primary);
  margin-bottom: var(--space-3);
`;

const ListBottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
`;

const ProjectDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;

const Status = styled.div`
  width: 14px;
  height: 14px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;
const ProjectName = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-full);
  height: 12px;
  width: 480px;
  &.w-390 {
    width: 390px;
  }
  &.w-280 {
    width: 280px;
  }
  &.w-170 {
    width: 170px;
  }
`;

const ProjectDetails = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const ProjectTitle = styled.p`
  max-width: 300px;
  margin: var(--space-0);
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  ${LineClamp(1)}
  word-break: break-all;
  white-space: pre-wrap;
  ${tablet(css`
    max-width: 170px;
  `)}
`;

export {
  SectionDiv,
  GradientDiv,
  CardContainer,
  CardIcon,
  TabSection,
  HeaderSection,
  TabItem,
  BottomSection,
  ListSection,
  ListTitle,
  BorderDiv,
  ListBottomSection,
  ProjectDiv,
  Status,
  ProjectName,
  ProjectDetails,
  ProjectTitle
};
